const formatErrorMessage = (errorMessage: string) => {
  return errorMessage.replace(/\[.*?\]/g, "");
};

export { formatErrorMessage };
